<?xml version="1.0" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20010904//EN"
 "http://www.w3.org/TR/2001/REC-SVG-20010904/DTD/svg10.dtd">
<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="1024.000000pt" height="1024.000000pt" viewBox="0 0 1024.000000 1024.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1024.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M5380 6324 l0 -216 -31 27 c-114 95 -302 109 -457 34 -182 -89 -280
-302 -243 -531 13 -77 47 -153 76 -168 26 -14 17 -20 161 109 50 46 50 46 45
96 -8 60 4 146 24 186 47 90 154 141 250 120 105 -24 172 -104 184 -220 l6
-57 105 -94 c58 -51 117 -105 133 -119 l27 -25 0 537 0 537 -140 0 -140 0 0
-216z"/>
<path d="M6580 6330 c0 -115 -3 -210 -6 -210 -3 0 -22 13 -42 30 -61 49 -115
64 -227 63 -80 0 -112 -4 -160 -23 -201 -77 -305 -251 -292 -490 8 -155 16
-169 174 -301 193 -161 176 -153 291 -147 107 5 168 26 234 78 20 17 39 30 42
30 3 0 6 -23 6 -50 l0 -51 130 2 130 1 0 639 0 639 -140 0 -140 0 0 -210z
m-159 -354 c47 -8 122 -73 142 -124 93 -234 -97 -449 -304 -344 -162 82 -168
354 -10 446 35 20 95 36 121 31 8 -2 31 -6 51 -9z"/>
<path d="M2230 5862 l0 -604 383 4 c352 5 388 7 461 26 187 51 275 159 264
321 -8 112 -63 195 -163 246 l-58 29 24 15 c49 31 107 99 123 147 47 140 -7
289 -131 357 -100 54 -154 60 -545 61 l-358 1 0 -603z m687 365 c68 -37 91
-118 51 -177 -43 -64 -80 -74 -275 -78 l-173 -4 0 142 0 142 183 -4 c151 -2
188 -6 214 -21z m50 -486 c49 -23 73 -55 80 -108 8 -63 -18 -110 -74 -136 -44
-20 -64 -22 -248 -22 l-200 0 -3 143 -3 142 203 0 c178 0 208 -3 245 -19z"/>
<path d="M3520 5890 c0 -190 4 -329 11 -362 36 -167 157 -265 340 -276 118 -6
206 20 272 81 26 24 49 41 52 39 3 -3 5 -29 5 -59 0 -52 1 -53 29 -53 22 0 45
13 83 49 29 26 74 66 100 87 l47 39 0 383 1 382 -139 0 -140 0 -3 -278 c-3
-275 -3 -278 -28 -327 -21 -39 -37 -55 -79 -77 -66 -35 -121 -36 -181 -5 -30
15 -50 35 -64 62 -20 37 -21 60 -24 333 l-3 292 -139 0 -140 0 0 -310z"/>
<path d="M6970 6192 c0 -15 239 -588 342 -819 l49 -111 -20 -41 c-38 -74 -127
-93 -216 -46 -26 14 -49 24 -50 23 -6 -6 -85 -181 -85 -188 0 -15 120 -60 187
-70 144 -20 281 29 355 126 36 49 172 361 418 967 l68 167 -133 0 -133 0 -92
-227 c-51 -126 -106 -263 -123 -305 -17 -42 -33 -75 -37 -73 -3 2 -60 139
-126 304 l-119 301 -142 0 c-79 0 -143 -3 -143 -8z"/>
<path d="M5129 5648 c-45 -40 -147 -130 -226 -199 l-144 -127 -72 44 c-39 24
-76 44 -82 44 -17 -1 -568 -470 -552 -470 2 0 63 36 136 80 74 44 140 80 147
80 7 0 26 16 41 36 15 20 66 67 113 106 93 77 107 75 71 -8 -12 -26 -19 -49
-17 -51 2 -3 18 3 35 11 65 34 55 11 -35 -84 l-76 -79 74 28 c205 80 224 94
299 218 65 107 143 182 191 183 9 0 32 21 51 48 20 26 52 63 71 81 l36 35 0
-97 c0 -107 -5 -121 -79 -232 -22 -32 -39 -61 -37 -63 2 -2 43 22 90 54 47 31
88 55 90 53 2 -2 18 -32 35 -66 17 -34 45 -73 63 -86 35 -27 168 -109 168
-104 0 2 -9 27 -19 57 -11 30 -16 56 -11 58 5 2 28 -7 52 -19 44 -23 384 -159
396 -159 4 0 -39 46 -94 103 -139 142 -133 127 -71 170 30 21 57 37 60 37 4 0
7 -14 7 -30 0 -44 21 -79 79 -133 27 -26 52 -47 54 -47 2 0 2 11 -1 25 -2 14
0 25 5 25 5 0 81 -41 169 -91 87 -50 179 -102 204 -116 l45 -24 -42 38 c-131
120 -500 433 -510 433 -4 0 -42 -23 -85 -51 l-79 -52 -22 20 c-12 11 -107 95
-212 188 -104 92 -200 177 -212 187 l-21 20 -83 -74z"/>
<path d="M2254 4971 c-110 -50 -113 -202 -4 -265 45 -26 130 -27 182 -2 110
53 112 213 4 265 -53 26 -127 27 -182 2z"/>
<path d="M5647 4976 c-68 -25 -97 -66 -97 -138 0 -142 185 -207 298 -104 32
30 36 39 39 92 5 69 -17 113 -68 139 -44 23 -126 28 -172 11z"/>
<path d="M6081 4280 l2 -620 138 0 139 0 0 604 c0 332 3 611 6 620 5 14 -11
16 -141 16 l-146 0 2 -620z"/>
<path d="M6590 4280 l0 -620 140 0 140 0 0 620 0 620 -140 0 -140 0 0 -620z"/>
<path d="M4270 4240 l0 -580 145 0 145 0 0 235 0 235 250 0 250 0 0 -235 0
-235 145 0 145 0 0 580 0 580 -145 0 -145 0 0 -230 0 -231 -247 3 -248 3 -3
228 -2 227 -145 0 -145 0 0 -580z"/>
<path d="M3155 4566 c-70 -18 -115 -39 -151 -69 -18 -15 -35 -27 -38 -27 -3 0
-6 20 -6 45 l0 45 -130 0 -130 0 0 -450 0 -450 140 0 140 0 0 254 c0 272 6
314 53 365 51 55 159 77 231 47 46 -19 84 -73 96 -136 5 -29 10 -160 10 -291
l0 -239 135 0 135 0 0 303 c0 317 -5 358 -48 443 -28 55 -111 128 -170 149
-63 22 -203 28 -267 11z"/>
<path d="M7283 4560 c-155 -41 -232 -126 -241 -267 -4 -64 -1 -79 23 -128 44
-91 108 -122 314 -156 141 -23 178 -38 187 -76 9 -33 -4 -54 -47 -75 -72 -37
-269 -13 -376 47 -24 13 -45 20 -47 17 -10 -18 -77 -185 -74 -187 12 -10 74
-36 128 -53 202 -65 439 -49 565 38 125 86 151 269 53 376 -50 54 -108 77
-269 104 -67 12 -137 27 -156 35 -58 24 -63 83 -11 115 72 44 235 29 379 -34
13 -6 23 11 52 88 21 53 37 98 37 100 0 3 -26 14 -57 26 -138 52 -329 64 -460
30z"/>
<path d="M2204 4561 c-2 -2 -4 -206 -4 -453 l0 -448 140 0 140 0 0 449 0 450
-136 3 c-75 2 -138 1 -140 -1z"/>
<path d="M5580 4113 l0 -453 140 0 140 0 0 454 0 454 -140 -1 -140 -2 0 -452z"/>
</g>
</svg>
